import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
export default defineComponent({
    name: 'product-description-entry-details',
    computed: Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })),
    data() {
        return {
            expanded: false,
        };
    },
    methods: {
        toggleExpansion() {
            this.expanded = !this.expanded;
        },
    },
});
